var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('header',{staticClass:"shadow bg-gray-50"},[_c('div',{staticClass:"px-8 py-4 mx-auto max-w-7xl space-y-2"},[_c('header-title'),_vm._v(" "),_c('header-buttons')],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }